module.exports = __webpack_public_path__ + "fonts/flaticon.b059ef79.eot";